import author from './author'

const churns = { author }

export default churns
